<div class="card title-card mb-4">
  <div class="flex align-items-center">
    <i class="pi mr-1 title-card-icon" [class.pi-plus-circle]="mode === 'create'" [class.pi-pencil]="mode === 'edit'"></i>
    <p class="mb-0 text-3xl title">
      {{(mode == 'create' ? 'misc.creation.cepRule' : 'misc.edition.cepRule') | transloco | capitalize}}
    </p>
  </div>
</div>
<div class="card step-card flex flex-column">
  <form [formGroup]="cepRuleForm" *ngIf="cepRuleForm">
    <div class="grid">
      <div class="col-12 md:col-12 lg:col-6 xl:col-4">
        <div class="form-field col-12">
          <label for="nameComplexRule">{{'attribute.name' | transloco}} (*)</label>
        </div>
        <div class="col-12">
          <input pInputText id="nameComplexRule" type="text" formControlName="nameComplexRule" class="w-full" (change)="onNameComplexRuleChange()">
        </div>
        <div *ngIf="(cepRuleForm.get('nameComplexRule').invalid && cepRuleForm.get('nameComplexRule').touched) || cepRuleForm.get('nameComplexRule').dirty">
          <small class="form-error-text" *ngIf="cepRuleForm.get('nameComplexRule').errors?.specialChars">{{'invalid.specialChars' | transloco}}</small>
          <small class="form-error-text" *ngIf="cepRuleForm.get('nameComplexRule').errors?.whitespaces && !cepRuleForm.get('nameComplexRule').errors?.specialChars">
            {{'invalid.whitespaces' | transloco}}
          </small>
        </div>
      </div>
      <div class="col-12 md:col-12 lg:col-6 xl:col-4">
        <div class="form-field col-12">
          <label for="tenant">{{'model.tenant' | transloco}} (*)</label>
        </div>
        <div class="col-12">
          <p-dropdown id="tenant" [filter]="true" [options]="tenants" placeholder="{{'select.tenant' | transloco}}"
                      optionLabel="name" formControlName="tenant" (onChange)="onTenantChange($event)" styleClass="w-full"></p-dropdown>
        </div>
      </div>
      <div class="col-12 md:col-12 lg:col-6 xl:col-4">
        <div class="form-field col-12">
          <label for="organization">{{'model.organization' | transloco}}</label><br>
        </div>
        <div class="col-12">
          <p-dropdown
            id="organization"
            [filter]="true"
            [options]="organizations"
            [showClear]="true"
            placeholder="{{'select.organization' | transloco}}"
            optionLabel="name"
            formControlName="organization"
            (onChange)="onOrganizationChange()"
            styleClass="w-full"></p-dropdown>
        </div>
      </div>
    </div>
  </form>

  <hr style="border-color: #eceeec; width: 65%;" class="mx-auto">
  <div class="grid mt-2">
    <div class="col-12 md:col-12 lg:col-12 xl:col-6">
      <div class="mt-auto">
        <div class="flex justify-content-end">
          <div class="mb-2">
            <p-button
              [label]="'forms.descriptions.simpleRule' | transloco"
              [disabled]="cepRuleForm === undefined || !isFormValid()"
              (onClick)="addSimpleRule()"
              icon="pi pi-plus"
              iconPos="left"
            ></p-button>
          </div>
        </div>
      </div>
      <p-orderList [value]="simpleRules" [dragdrop]="true" (onSelectionChange)="selectRules($event.value)" *ngIf="simpleRules"
                   [selection]="[selectedRule]" [listStyle]="{'max-height':'43rem', 'min-height': '43rem'}" [styleClass]="'mt-2'">
        <ng-template let-rule pTemplate="item">
          <div class="grid">
            <div class="col-6">
              <label class="flex align-items-center">
                <b>{{'attribute.name' | transloco}}:&nbsp;</b>{{rule.name}}
              </label>
            </div>
            <div class="col-6">
              <label class="flex align-items-center">
                  <b>{{'attribute.windowTime' | transloco}}:</b>&nbsp;
                <span *ngIf="rule.windowTime">{{rule.windowTime}} {{'common.minutes' | transloco}}</span>
                <span *ngIf="!rule.windowTime">-</span>
              </label>
            </div>
            <div class="col-6">
              <label class="flex align-items-center">
                <b>{{'attribute.function' | transloco}}:</b>&nbsp;
                <span *ngIf="rule.aggregatorFunctionType">{{rule.aggregatorFunctionType}}</span>
                <span *ngIf="!rule.aggregatorFunctionType">-</span>
              </label>
            </div>
            <div class="col-6">
              <label class="flex align-items-center">
                <b>{{'attribute.condition' | transloco}}:</b>&nbsp;
                <span *ngIf="rule.limitOperatorType && rule.limitValue != undefined">{{rule.limitOperatorType}}({{rule.limitValue}})</span>
                <span *ngIf="!rule.limitOperatorType || rule.limitValue == undefined">-</span>
              </label>
            </div>
            <div class="col-12">
              <label class="flex align-items-center">
                <b>{{'attribute.transformationCondition' | transloco}}:</b>&nbsp;
                <span *ngIf="rule.transformationOption">{{rule.transformationType}}({{rule.transformationValue}})</span>
                <span *ngIf="!rule.transformationOption">{{'common.no' | transloco}}</span>
              </label>
            </div>
          </div>
        </ng-template>
      </p-orderList>
    </div>
    <div class="col-12 md:col-12 lg:col-12 xl:col-6" *ngIf="selectedRule">
      <div class="mt-auto">
        <div class="flex justify-content-end">
          <div class="mb-2">
            <p-button
              (onClick)="removeSimpleRule()"
              icon="pi pi-trash"
              styleClass="p-button-danger"
              iconPos="left"
              label="{{'primeng.removeSimpleRule' | transloco}}"
              class="mr-2"
            >
            </p-button>
          </div>
        </div>
      </div>
      <div class="grid">
        <div class="col-12 md:col-12 lg:col-6">
          <div class="form-field col-12">
            <label>{{'attribute.transformationOption' | transloco}}: (*)</label>
          </div>
          <div class="col-12 p-3">
            <p-radioButton
              [label]="'common.no' | transloco"
              (ngModelChange)="selectedRule.transformationType = undefined; selectedRule.transformationValue = undefined"
              name="transformationOption"
              class="mr-3"
              [value]="false"
              [(ngModel)]="selectedRule.transformationOption"
            ></p-radioButton>
            <p-radioButton
              [label]="'common.yes' | transloco"
              (ngModelChange)="selectedRule.transformationType = 'BYTE_MASK'; selectedRule.transformationValue = '0'"
              name="transformationOption"
              [value]="true"
              [(ngModel)]="selectedRule.transformationOption"
            ></p-radioButton>
          </div>
        </div>
        <div *ngIf="selectedRule.transformationOption" class="col-12 md:col-12 lg:col-6">
          <div class="form-field col-12">
            <label for="transformationType">{{'attribute.transformationType' | transloco}}: (*)</label>
          </div>
          <div class="col-12">
            <p-dropdown id="transformationType" [(ngModel)]="selectedRule.transformationType" [options]="transformationTypes"
                        styleClass="w-full" placeholder="{{'select.transformationType' | transloco}}"></p-dropdown>
          </div>
        </div>
        <div *ngIf="selectedRule.transformationOption" class="col-12 md:col-12">
          <div class="form-field col-12">
            <label>{{'attribute.transformationValue' | transloco}}: (*)</label>
          </div>
          <div class="col-12" *ngIf="selectedRule.transformationType !== 'BYTE_MASK'">
            <input pInputText id="transformationValue" type="text" [(ngModel)]="selectedRule.transformationValue" class="w-full">
          </div>
          <div class="col-12" *ngIf="selectedRule.transformationType === 'BYTE_MASK'">
            <app-byte-input [(ngModel)]="selectedRule.transformationValue"></app-byte-input>
          </div>
        </div>
      </div>
      <div class="grid">
        <div class="col-12 md:col-12 lg:col-6">
          <div class="form-field col-12">
            <label for="aggregatorFunctionType">{{'attribute.aggregatorFunctionType' | transloco}}: (*)</label>
          </div>
          <div class="col-12">
            <p-dropdown id="aggregatorFunctionType" [(ngModel)]="selectedRule.aggregatorFunctionType" [options]="aggregatorFunctionTypes"
                        styleClass="w-full" placeholder="{{'select.function' | transloco}}"></p-dropdown>
          </div>
        </div>
        <div class="col-12 md:col-12 lg:col-6">
          <div class="form-field col-12">
            <label for="limitOperatorType">{{'attribute.limitOperator' | transloco}}: (*)</label>
          </div>
          <div class="col-12">
            <p-dropdown id="limitOperatorType" [(ngModel)]="selectedRule.limitOperatorType" [options]="limitOperatorTypes"
                        styleClass="w-full" placeholder="{{'select.operator' | transloco}}"></p-dropdown>
          </div>
        </div>
        <div class="col-12 md:col-12 lg:col-6">
          <div class="form-field col-12">
            <label for="limitValue">{{'attribute.limitValue' | transloco}}: (*)</label>
          </div>
          <div class="col-12">
            <input pInputText id="limitValue" type="number" step="0.01" class="w-full" [(ngModel)]="selectedRule.limitValue">
          </div>
        </div>
        <div class="col-12 md:col-12 lg:col-6">
          <div class="form-field col-12">
            <label for="windowTime">{{'attribute.windowTimeForm' | transloco}}: (*)</label>
          </div>
          <div class="col-12">
            <input pInputText id="windowTime" type="number" min="1" class="w-full" [(ngModel)]="selectedRule.windowTime">
          </div>
        </div>
      </div>

      <hr style="border-color: #eceeec; width: 65%;" class="mx-auto">
      <div class="grid">
        <div class="col-12">
          <div class="col-12">
            <p class="font-bold">{{'model.entities' | transloco}}:</p>
          </div>
          <div class="col-12">
            <button
              (click)="displayEntityMeasurementSelector = true;"
              pButton
              class="w-full"
              icon="pi pi-plus"
              [label]="'forms.descriptions.entityMeasurements' | transloco"
            ></button>
          </div>
          <div class="col-12">
            <p-table
              [(first)]="selectedFirst"
              [(rows)]="selectedRows"
              [value]="selectedEntities"
              [totalRecords]="selectedEntities.length"
              [paginator]="true"
              [autoLayout]="true"
              responsiveLayout="stack"
              styleClass="fade-in"
              [loading]="loadingSelected"
            >
              <ng-template pTemplate="header">
                <tr>
                  <th class="selection-column-width"></th>
                  <th>{{'model.entity' | transloco}}</th>
                  <th>{{'attribute.entityType' | transloco}}</th>
                  <th>{{'attribute.measurementName' | transloco}}</th>
                  <th>{{'model.measurementUnit' | transloco}}</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-entity>
                <tr>
                  <td>
                    <button
                      (click)="deselectEntity(entity)"
                      pButton
                      class="p-button-icon-only p-button-text p-0 w-auto"
                      icon="pi pi-minus"
                    ></button>
                  </td>
                  <td>
                    <p>{{entity.identifier}}</p>
                  </td>
                  <td>
                    <p *ngIf="entity.entityType === 'DEVICE'">{{'model.device' | transloco}}</p>
                    <p *ngIf="entity.entityType === 'ASSET'">{{'model.asset' | transloco}}</p>
                  </td>
                  <td>
                    <p>{{entity.measurementName}}</p>
                  </td>
                  <td>
                    <p>{{entity.measurementTypeUnit ?? '-'}}</p>
                  </td>
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage">
                <tr>
                  <td colspan="5">
                    <p>{{'empty.entities' |  transloco}}</p>
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
      </div>
      <app-entities-measurement-selector
        [(selectedEntities)]="selectedEntities"
        [(visible)]="displayEntityMeasurementSelector"
        [cepRule]="cepRule"
        [hasBeenOpened]="hasBeenOpened"
        (hasBeenOpenedChange)="updateHasBeenOpened($event)"
        (selectedEntitiesChange)="refreshEntities()"
      ></app-entities-measurement-selector>
    </div>
  </div>

  <div class="mt-auto">
    <div class="flex justify-content-between mt-4">
      <button
        [label]="'common.cancel' | transloco"
        [routerLink]="'/alarms/cep-rules'"
        pButton
        class="p-button-danger"
        iconPos="right"
      ></button>
      <p-button
        *ngIf="cepRuleForm"
        [label]="(mode == 'creation' ? 'common.create' : 'common.save') | transloco"
        [disabled]="!isFormValid() || !validSimpleRules()"
        [loading]="persistingChanges"
        (onClick)="persistCepRuleData()"
        styleClass="p-button-primary"
        class="mr-2"
      ></p-button>
    </div>
  </div>
</div>
